import React from 'react';

export const Match = ({ children, param, data, ...props }) => {
  const find = props.match.params[param];
  const item = data.filter(item => item.path.indexOf(find) !== -1)[0];
  console.log(find, item);
  return item && React.cloneElement(children, { data: item, ...props });
};
